import { ApplicationInsights, ITelemetryItem } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';

let reactPlugin = null;
let appInsights: ApplicationInsights = null;

interface TelemetryServiceInfo {
    reactPlugin: any;
    appInsights: ApplicationInsights;
    initialize: (instrumentationKey, browserHistory) => void;
}

const createTelemetryService = (): TelemetryServiceInfo => {
    const initialize = (instrumentationKey, browserHistory): void => {
        if (!browserHistory) {
            console.error('Could not initialize Telemetry Service');
            return;
        }
        if (!instrumentationKey) {
            console.error('Instrumentation key not provided')
            return;
        }

        reactPlugin = new ReactPlugin();

        appInsights = new ApplicationInsights({
            config: {
                instrumentationKey: instrumentationKey,
                maxBatchInterval: 0,
                disableFetchTracking: false,
                loggingLevelConsole: 2,
                extensions: [reactPlugin],
                extensionConfig: {
                    [reactPlugin.identifier]: {
                        history: browserHistory,
                        debug: true
                    }
                }
            }
        });

        appInsights.loadAppInsights();
    };

    return { reactPlugin, appInsights, initialize };
};

export const setSharedProperties = (props: Map<string, string>): void => {
    if (appInsights) {
        const telemetryInitializer = (item: ITelemetryItem): void => {
            props.forEach((value, key) => {
                // eslint-disable-next-line security/detect-object-injection
                item.data[key] = value;
            });
        }
        appInsights.addTelemetryInitializer(telemetryInitializer);
    }
}

export const ai = createTelemetryService();
export const getAppInsights = (): ApplicationInsights => appInsights;
